// extracted by mini-css-extract-plugin
export default {"container":"appSwitchButton_container__P9pcr","active":"appSwitchButton_active__Hlxke","inactive":"appSwitchButton_inactive__rxOGX"};